import React, { useState } from "react";
import { MdDeleteSweep } from "react-icons/md";
import axiosInstance from "../utils/axios-instance";
import { toast } from "sonner";
import EditPromptModal from "./editPromptModal";

const PromptList = ({ prompts, onDeleteSuccess, onEditSuccess }) => {
    const [showModal, setShowModal] = useState(false);
    const [, setLoading] = useState(true);
    const [selectedPrompt, setSelectedPrompt] = useState({ id: null, name: "" });
    const [promptToEdit, setPromptToEdit] = useState({}); 

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    const handleOpen = () => setIsEditModalOpen(true);
    const handleClose = () => setIsEditModalOpen(false);

    const handleSubmit = async (data) => {
        try {
            const res = await axiosInstance.post("/prompt/edit", data);
            if (res.status === 200) {
                toast.success(res.data.message);
                onEditSuccess();
                setIsEditModalOpen(false);
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            // console.error(error.response.data.message); 
            toast.error(error.response.data.message);
        } finally {
            setLoading(false);
        }
    };

    const handleEditClick = (id) => {
        const prompt = prompts.find((prompt) => prompt.id === id);  
        setPromptToEdit(prompt);
        handleOpen();
    }

    const handleDeleteClick = (id, name) => {
        setSelectedPrompt({ id, name });
        setShowModal(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const res = await axiosInstance.delete(`/prompt/deleteprompt?id=${selectedPrompt.id}`);
            if (res.status === 200) {
                toast.success(`${selectedPrompt.name} deleted successfully`);
                onDeleteSuccess(selectedPrompt.id);
                setShowModal(false);
                setSelectedPrompt({ id: null, name: "" });
            }

        } catch (error) {
            toast.error("Failed to delete prompt");
        }
    };


    return (
        <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 text-sm text-left">
                <thead className="bg-gray-100">
                    <tr>
                        <th className="px-4 py-2 border">S/N</th>
                        <th className="px-4 py-2 border">Name</th>
                        <th className="px-4 py-2 border">Content</th>
                        <th className="px-4 py-2 border">Created At</th>
                        <th className="px-4 py-2 border">Action</th>
                    </tr>
                </thead>
                <tbody>
                    {prompts?.map((prompt, index) => (
                        <tr key={prompt.id} className="hover:bg-gray-50">
                            <td className="px-4 py-2 border">{index + 1}</td>
                            <td className="px-4 py-2 border">{prompt.name}</td>
                            <td className="px-4 py-2 border">{prompt.content.length > 15 ? prompt.content.slice(0, 15) + "..." : prompt.content}</td>
                            <td className="px-4 py-2 border">
                                {new Date(prompt.createdAt).toLocaleString()}
                            </td>
                            <td className="px-4 py-2 border flex justify-center space-x-2 text-center">
                                <button
                                    onClick={() => handleEditClick(prompt.id)}  
                                    className={`p-2 rounded-md bg-brandPrimary text-white`}
                                    aria-label="Grid view"
                                >
                                    Edit
                                </button>
                                <button
                                    onClick={() => handleDeleteClick(prompt.id, prompt.name)}
                                    className={`p-2 rounded-md bg-red-500 text-white`}
                                    aria-label="Grid view"
                                >
                                    <MdDeleteSweep className="h-5 w-5" />
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>



            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded shadow-md w-[300px] text-center">
                        <p className="mb-4 text-lg font-medium">
                            Are you sure you want to delete <span className="font-bold">{selectedPrompt.name || 'this prompt'}</span>?
                        </p>
                        <div className="flex justify-center gap-4">
                            <button
                                className="bg-gray-300 px-4 py-2 rounded"
                                onClick={() => setShowModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="bg-red-600 text-white px-4 py-2 rounded"
                                onClick={handleConfirmDelete}
                            >
                                Yes, Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <EditPromptModal
                prompt={promptToEdit}
                isOpen={isEditModalOpen}
                onClose={handleClose}
                onSubmit={handleSubmit}
            />

        </div>
    );
};

export default PromptList;
